import {
    DETAIL_APPLICANT_STATUSES
} from '@Utils/constants';

export const getDDLData = (datatype = 'femployeeid') => ({ dropdown }) => {
    switch (datatype) {
        case 'fbatch':
            return dropdown.batches
        case 'fsection':
            return dropdown.sections
        case 'fdepartment':
            return dropdown.departments
        case 'fleavetype':
            return dropdown.leavetypes
        case 'femployeeclass':
        case 'fcompclass':
            return dropdown.compclasses
        case 'fperiod':
            return dropdown.periods
        case 'fincome':
            return dropdown.incomes
        case 'fdeduction':
            return dropdown.deductions
        case 'fposition':
            return dropdown.positions
        case 'fshift':
            return dropdown.shifts
        case 'fjob':
            return dropdown.jobs
        case 'fjoblevel':
            return dropdown.joblevels
        case 'fsalarygrade':
            return dropdown.salarygrades
        case 'fempapprover':
            return dropdown.employeeApprovers
        case 'fjobclass':
            return dropdown.jobclasses
        case 'fjobhiring':
            return dropdown.jobhiring
        case 'fapplicant':
            return dropdown.applicant
        case 'fjoapplicant':
            return dropdown.joapplicant
        case 'fjoapplicantid':
            return dropdown.joapplicantid
        case 'AISbusinessunit':
            return dropdown.aisBusinessunits
        case 'AISposition':
            return dropdown.aisPositions
        case 'AISproject':
            return dropdown.aisProjects
        case 'fapplicanttoken':
            return dropdown.applicantTokens
        case 'finterviewer':
            return dropdown.interviewers
        case 'fapplicantapplied':
            return dropdown.applicantApplied
        case 'fpositionaccepted':
            return dropdown.positionAccepted
        case 'ffilteredaddapplicant':
            return dropdown.filteredAddApplicant
        case 'ffilteredupdateapplicant':
            return dropdown.filteredUpdateApplicant
        case 'ffilteredsearchapplicant':
            return dropdown.filteredSearchApplicant
        case 'ftrainingcategory':
            return dropdown.trainingCategory
        case 'ftrainingname':
            return dropdown.trainingName
        case 'fjobtitle':
            return dropdown.jobTitle
        case 'fonboardingtype':
            return dropdown.onboardingType
        case 'fonboardingstatus':
            return dropdown.onboardingStatus
        case 'fonboardingfacilitator':
            return dropdown.onboardingfacilitator
        case 'fonboardingprobationary':
            return dropdown.onboardingprobationary
        case 'fschools':
            return dropdown.schools
        case 'fjobsource':
            return dropdown.jobsource
        case 'fjoapprovalstatus':
            return dropdown.joapprovalstatus
        case 'fjobofferstatus':
            return dropdown.jobofferstatus
        case 'faccesslevel':
            return dropdown.accesslevel
        case 'fERFStatus':
            return dropdown.erfStatus    
        case 'fERFTrackerStatus':
            return dropdown.erfTrackerStatus   
        case 'fHiredCandidate':
            return dropdown.hiredCandidate
        case 'fcivilstatus':
            return dropdown.civilStatus
        case 'fgenderddl':
            return dropdown.genderDDL
        case 'fApplicantType':
            return dropdown.applicantType
        case 'fApplicantStatus':
            return dropdown.applicantStatus
        case 'fDetailApplicantStatus':
            return dropdown.detailApplicantStatus
                ? {
                    ...dropdown.detailApplicantStatus,
                    items: (dropdown.detailApplicantStatus.items || []).map(s => ({
                    ...s,
                    disabled: !DETAIL_APPLICANT_STATUSES.includes(s.name)
                    }))
                }
                : dropdown.detailApplicantStatus;
        case 'fInterviewApplicantStatus':
            return dropdown.interviewApplicantStatus
        case 'fInterviewResults':
            return dropdown.intervewResults
        case 'fBackgroundCheckStatus':
            return dropdown.backgroundCheckStatus
        case 'fonboardingTrainingStatus':
            return dropdown.onboardingTrainingStatus
        case 'feducationlevel':
            return dropdown.educationlevel
        case 'finteriewMode':
            return dropdown.interviewMode
        case 'ferfrequestType':
            return dropdown.erfrequestType 
        case 'fjobpostedstatus':
            return dropdown.jobpostedstatus   
        case 'fequipmentType':
            return dropdown.equipmentType   
        case 'fhiringManager':
            return dropdown.hiringManager
        case 'fprojectLeader':
            return dropdown.projectLeader            
        default:
            return dropdown.employees
    }
}
